import { completingCompanyDetailsSectionValidationMap } from 'mittweida/inquiry/steps/company/sections/completingCompanyDetailsSection/fieldValidations';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import { validateFieldValidationMap, ValidateSectionFunction } from 'new/form/useValidateFields';

export const validateCompletingCompanyDetailsSection: ValidateSectionFunction<
  InquiryType.profiMittweida
> = (form, values, store, conditions) => {
  return validateFieldValidationMap({
    validationMap: completingCompanyDetailsSectionValidationMap,
    form,
    values,
    conditions,
  });
};
